import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter ,Routes, Route} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../node_modules/video-react/dist/video-react.css";
import './index.css';
import './style.css'


import Admin from './view/admin';
import App from './view/App';
import Gallery from './view/gallery'
import About from './view/about';
import Contact from './view/contact'
import Goals from './view/goals';
import News from './view/news';
import DynamicSection from './view/DynamicSection';
import AIGenerator from './view/ai-generator';
import VisitorPresenceTracker from './components/VisitorPresenceTracker';
import GlobalVisitorCounter from './components/GlobalVisitorCounter';
import GlobalFeedbackWidget from './components/GlobalFeedbackWidget';


function App1(){
return(
<BrowserRouter dir="rtl" >  
<VisitorPresenceTracker />
<GlobalVisitorCounter />
<GlobalFeedbackWidget />
<Routes>
    <Route path="/" exact element={<App />} />
    <Route path="admin" element={<Admin />} />
    <Route path="gallery" element={<Gallery />} />
    <Route path="contact-us" element={<Contact />} />
    <Route path="about-us" element={<About />} />
    <Route path="goals" element={<Goals />} />
    <Route path="news" element={<News />} />
    <Route path="ai-generator" element={<AIGenerator />} />
    <Route path=":sectionKey" element={<DynamicSection />} />
</Routes>
  
</BrowserRouter>
);
}
const roote= document.getElementById("root");
ReactDOM.render(<App1 />, roote);